// extracted by mini-css-extract-plugin
module.exports = {"banner":"image-banner-module--banner--1FURD","isFixed":"image-banner-module--isFixed--1akuO","banner__img":"image-banner-module--banner__img--3pg-1"};